import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useSelector } from "react-redux";
import { IGetFormRejectReasonsResponse } from "../../models/registration.model";
import { RootState } from "../../redux/store";
import { getFormRejectReasons } from "../../services/registration.service";
import { IFormInnerState } from "../requestSteps/form/IFormInnerState";
import CaptureVideo from "./captureVideo";
import VideoError from "./videoError";
import VideoHints from "./videoHints";
export default function KycVideo({ setFormInnerState, setStep, referenceKey }: IFormInnerState) {
    const [state, setState] = useState<'videoHint' | 'captureVideo'>('videoHint');
    const stateFromRedux = useSelector((state: RootState) => state.prevAndNextState.nextInnerState) as ('videoHint' | 'captureVideo');
    const [rejectReasons, setRejectReasons] = useState<string[]>([]);

    const { mutate: GetRejectReasonsMutate } = useMutation(
        getFormRejectReasons,
        {
            onSuccess: (data: IGetFormRejectReasonsResponse[]) => {

                if (data) {
                    setRejectReasons(data[0]?.rejectReasons)
                }
            },
        }
    );

    useEffect(() => {
        GetRejectReasonsMutate({
            referenceKey: referenceKey!,
            form: "KycVideo"
        })
    }, [])


    useEffect(() => {
        if (stateFromRedux.includes('videoHint'))
            setState('videoHint')
    }, [stateFromRedux])
    if (state === 'videoHint') {
        return (
            rejectReasons && rejectReasons?.length !== 0 ?
                <VideoError setState={setState} referenceKey={referenceKey!} rejectReasons={rejectReasons} />
                :
                <VideoHints setState={setState} referenceKey={referenceKey!} />
        )
    }
    return (
        <CaptureVideo setStep={setStep} referenceKey={referenceKey!} />
    )
}
